import ImportDetailsPage from '@/pages/catalog/ImportDetailsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/import/$id')({
  component: ImportDetailsPage,
})
